import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import type { VehicleByUuidResponse } from "@/common/api/vehicle/use-vehicle-by-uuid.query";
import { CarCutterWebPlayer } from "@/components/car-cutter-web-player/car-cutter-web-player";
import { ButtonSize } from "@/components/ui/button";
import { VehicleInfoCard } from "@/components/vehicle-info-card/vehicle-info-card";
import { VehicleSnapshotAction } from "@/components/vehicle-snapshot/vehicle-snapshot-action";
import { VEHICLE_SNAPSHOT_SUBJECT } from "@/modules/masterdata/vehicle/vehicle-snapshot.permissions";

export function OverviewTab({ uuid, vehicle }: { uuid: string; vehicle: VehicleByUuidResponse }) {
  const ability = useAbility();
  const vehicleSnapshotAction = ability.can(Action.Read, VEHICLE_SNAPSHOT_SUBJECT) ? (
    <VehicleSnapshotAction size={ButtonSize.Sm} vehicleUuid={uuid} showInCommandPalette />
  ) : undefined;

  return (
    <div className="grid items-stretch gap-6 xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
      <VehicleInfoCard headerActions={vehicleSnapshotAction} vehicle={vehicle} showVehicleDetailLink={false} />
      <CarCutterWebPlayer vin={vehicle.vin} />
    </div>
  );
}
